var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoShowLady(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 572.826 512.288",
    style: {
      width: "100%",
      height: "100%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m560.939,344.804c0,62.745-21.199,120.539-56.823,166.609H72.494c-35.624-46.07-56.823-103.864-56.823-166.609,0-150.573,122.067-272.628,272.64-272.628s272.628,122.055,272.628,272.628Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m560.939,344.804c0,62.745-21.199,120.539-56.823,166.609H72.494c-35.624-46.07-56.823-103.864-56.823-166.609,0-150.573,122.067-272.628,272.64-272.628s272.628,122.055,272.628,272.628Z",
    fill: "#367cff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m375.134,108.167s2.294,35.582,9.017,46.149c19.355,30.42,25.259,54.378,6.44,72.606-18.819,18.228-140.177,19.884-149.85-21.43-8.144-34.782,8.423-38.724,12.132-67.537,1.678-13.037,6.393-40.389,6.393-40.389",
    fill: "#0a0a0a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sk",
    d: "m271.636,198.887c.21-.027,2.534,38.549,47.349,35.186,31.025-2.324,42.086-35.24,42.797-35.24-3.345-.711-8.978-1.745-10.463-2.538-4.885-2.625-10.93-5.356-12.505-14.843-.908-5.468.632-33.442.158-38.974l-47.623,10.629c.665,11.684,5.323,38.772-11.001,43.566-2.716.793-5.642,1.522-8.713,2.215Z",
    fill: "#ff9e85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sh",
    d: "m290.682,185.602c.675-2.153,1.076-4.025,1.433-7.391.638-6.019.298-11.553-.311-17.191,9.621-1.281,18.857-5.327,26.32-11.531.884,3.266,5.748,17.535,4.401,20.639-2.545,5.867-14.506,15.474-31.843,15.474Z",
    fill: "#0c0c0c",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296.994,173.461c18.795,1.604,38.948-6.203,43.691-31.263l8.331-22.601c4.743-25.06-4.575-47.866-28.17-52.332h0c-23.595-4.465-42.548,3.335-47.291,28.395,0,0-2.927,14.338-3.378,19.188-1.701,18.289-1.701,56.178,26.817,58.613Z",
    fill: "#ff9e85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e1_eb",
    d: "m274.117,105.9c.087.813,3.147.728,7.218.088,4.072-.64,7.677-1.399,7.527-2.406-.19-1.272-3.662-1.781-7.734-1.141-4.072.64-7.147,2.181-7.011,3.459Z",
    fill: "#0a0a0a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m367.892,127.478l-26.566,7.329c-16.019-6.482-15.449-45.421-15.449-45.421,0,0-19.458,18.965-66.611,8.178,0,0,9.455-63.67,79.117-44.549,22.462,6.166,38.584,30.891,36.575,61.143-1.407,21.2-7.066,13.318-7.066,13.318Z",
    fill: "#0a0a0a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m341.826,149.566c7.171,1.357,14.554-1.191,16.567-11.991,1.338-7.174-4.482-12.619-11.653-13.976l-4.604,4.105-6.475,20.695,6.165,1.167Z",
    fill: "#ff9e85"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "e1_eye",
    cx: 279.608,
    cy: 116.366,
    r: 2.612,
    fill: "#0a0a0a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "e1_n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m294.871,138.668c.529,0,.982-.399,1.038-.936.06-.574-.356-1.088-.931-1.148l-5.533-.579,3.406-11.053c.169-.552-.14-1.136-.692-1.306-.551-.169-1.136.139-1.306.691l-3.779,12.267c-.092.299-.045.623.128.884s.452.431.763.463l6.798.711c.037.004.073.006.109.006Z",
    fill: "#0a0a0a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "e1_m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m306.172,143.597c-9.457.515-11.96,6.383-12.072,6.658-.217.535.04,1.144.574,1.362.531.217,1.138-.038,1.359-.568.105-.249,2.687-6.019,13.161-5.342.588.04,1.074-.4,1.111-.975.037-.576-.4-1.073-.975-1.11-1.13-.073-2.182-.077-3.158-.024Z",
    fill: "#0a0a0a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "e1_eb-2",
    "data-name": "e1_eb",
    d: "m305.843,105.353c-.251.778,2.58,1.942,6.562,3.009s7.585,1.836,7.856.854c.342-1.24-2.625-3.114-6.606-4.181-3.981-1.067-7.417-.907-7.811.317Z",
    fill: "#0a0a0a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "e1_eye-2",
    "data-name": "e1_eye",
    cx: 305.801,
    cy: 118.031,
    r: 2.612,
    fill: "#0a0a0a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m337.583,114.044c.027,2.198-5.516,10.1-4.747,12.16,1.213,3.249,6.271,8.486,8.489,8.602,3.906.205.521-6.69,5.286-10.466.764-.064,1.547-.074,2.336.03,3.172.377,5.906,1.96,7.798,4.236l-.328-9.966",
    fill: "#0a0a0a"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m422.995,512.288h-114.671l-6.881-91.523,117.448,4.133s1.421-10.671,1.492,9.557c.047,14.034,2.978,41.853,2.611,77.833Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350.024,415.506c-.107,2.179-.225,4.37-.367,6.549-1.836,30.366-6.016,60.542-12.554,90.233h-114.618c1.492-46.472,2.736-83.281,2.736-83.281l76.222-8.243,4.571-.497,44.009-4.761Z",
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m51.529,197.002c.92-1.804,2.795-2.661,4.599-2.435,0-.081.002-.165.051-.236.09-.124.229-.16.369-.15l-3.119-2.236c-1.885-1.351-2.655-3.918-1.544-5.954,1.152-2.112,3.639-2.875,5.7-2.017-.008-.044.022-.086.028-.132l-1.282-.919c-1.773-1.271-2.539-3.636-1.625-5.617,1.231-2.666,4.483-3.436,6.745-1.814l2.958,2.12c.009-.017,0-.038.012-.054.013-.022.044-.022.061-.04-1.368-1.541-1.548-3.872-.297-5.617,1.396-2.246,4.619-1.787,6.531-.417l17.407,12.024-3.111-5.238c-1.248-2.1-.793-4.917,1.239-6.273,2.167-1.446,5.075-.766,6.388,1.445l16.988,28.6c4.144,6.976,1.986,15.983-4.869,20.324h0c-7.822,4.953-17.867,4.665-25.392-.729l-26.287-18.842c-1.734-1.243-2.519-3.893-1.55-5.793Z",
    fill: "#ff9e85"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "m81.64,189.496c-.133.182-.388.226-.574.097l-16.539-11.456c-.189-.131-.236-.39-.105-.579.109-.187.391-.236.579-.105l16.539,11.456c.189.131.236.39.105.579l-.006.008Z",
    fill: "#0c0c0c"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "m76.789,196.93c-.133.182-.388.226-.574.097l-18.458-12.784c-.189-.131-.236-.39-.105-.579.121-.172.39-.236.579-.105l18.458,12.784c.189.131.236.39.105.579l-.006.008Z",
    fill: "#0c0c0c"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "m71.581,205.011c-.133.182-.388.226-.574.097l-14.724-10.198c-.189-.131-.236-.39-.105-.579.136-.188.39-.236.579-.105l14.724,10.198c.189.131.236.39.105.579l-.006.008Z",
    fill: "#0c0c0c"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m117.118,191.726l42.285,97.645,58.341-79.847,50.555,45.579-86.336,111.814-.566.796c-3.011,4.135-6.991,7.661-11.824,10.203-16.867,8.87-37.731,2.388-46.601-14.479l-60.803-141.151,54.95-30.559Z",
    fill: "#367cff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m164.294,299.588c.098,0,.196-.022.288-.069.312-.158.436-.541.276-.853l-4.891-9.584c-.158-.312-.542-.434-.853-.276-.312.158-.436.541-.276.853l4.891,9.584c.111.219.334.345.564.345Z",
    fill: "#0c0c0c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m215.119,285.855c1.439,16.9,8.436,122.334,9.819,143.15h195.347c1.077-18.774,1.174-100.868,5.258-137.581,3.898-35.033,11.545-52.573,5.939-62.93-9.16-16.927-22.313-32.193-47.534-34.304-10.48-.877-29.818,2.862-29.818,2.862,0,0-1.327,26.848-32.973,28.342-43.079,2.032-40.216-28.269-40.416-28.342-8.88-3.247-39.789-4.899-53.402,4.09-25.968,17.148-15.273,48.901-12.22,84.714Z",
    fill: "#367cff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.07,
    y: 296.838,
    width: 1.267,
    height: 26.88,
    transform: "translate(-17.232 12.777) rotate(-3.248)",
    fill: "#0c0c0c"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m572.218,208.849c-1.082-1.712-3.028-2.392-4.803-2.001-.008-.081-.017-.164-.073-.231-.101-.116-.243-.138-.382-.116l2.9-2.513c1.753-1.519,2.283-4.146.989-6.071-1.342-1.996-3.888-2.527-5.862-1.483.004-.045-.03-.084-.04-.128l1.191-1.033c1.649-1.429,2.194-3.854,1.101-5.743-1.471-2.541-4.78-3.008-6.884-1.185l-2.75,2.383c-.01-.017-.004-.038-.017-.053-.015-.021-.045-.018-.064-.034,1.221-1.661,1.185-3.998-.221-5.621-1.597-2.108-4.764-1.354-6.541.187l-16.226,13.576,2.616-5.502c1.049-2.206.337-4.969-1.812-6.132-2.291-1.24-5.124-.295-6.228,2.028l-14.282,30.043c-3.484,7.328-.506,16.098,6.72,19.789h0c8.245,4.212,18.221,2.999,25.217-3.064l24.44-21.183c1.612-1.397,2.15-4.108,1.01-5.911Z",
    fill: "#ff9e85"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "m541.544,204.148c.149.169.407.19.58.044l15.414-12.93c.176-.148.199-.41.051-.587-.126-.177-.411-.199-.587-.051l-15.414,12.93c-.176.148-.199.41-.051.587l.006.007Z",
    fill: "#0c0c0c"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "m547.059,211.103c.149.169.407.19.58.044l17.202-14.43c.176-.148.199-.41.051-.587-.136-.16-.41-.199-.587-.051l-17.202,14.43c-.176.148-.199.41-.051.587l.006.007Z",
    fill: "#0c0c0c"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "m552.989,218.671c.149.169.407.19.58.044l13.722-11.51c.176-.148.199-.41.051-.587-.153-.175-.41-.199-.587-.051l-13.722,11.51c-.176.148-.199.41-.051.587l.006.007Z",
    fill: "#0c0c0c"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m508.127,207.589l-32.144,82.434-46.933-65.904-50.555,45.579,72.393,110.546.566.796c3.011,4.135,6.991,7.661,11.824,10.203,16.867,8.87,37.731,2.388,46.601-14.479l51.93-139.883-53.682-29.291Z",
    fill: "#367cff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m471.092,300.24c-.098,0-.196-.022-.288-.069-.312-.158-.436-.541-.276-.853l4.891-9.584c.158-.312.542-.434.853-.276.312.158.436.541.276.853l-4.891,9.584c-.111.219-.334.345-.564.345Z",
    fill: "#0c0c0c"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m531.864,512.282H50.881c-.654,0-1.184-.531-1.184-1.184s.53-1.184,1.184-1.184h480.982c.654,0,1.184.531,1.184,1.184s-.53,1.184-1.184,1.184Z",
    fill: "#292a2e"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m162.841,131.272V10.245C162.841,4.587,158.254,0,152.596,0H10.245C4.587,0,0,4.587,0,10.245v90.241c0,5.658,4.587,10.245,10.245,10.245h115.671s32.262,22.945,32.262,22.945c1.954,1.39,4.662-.007,4.662-2.405Z",
    fill: "#0cbc8b"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 77.039,
    cy: 89.78,
    r: 6.27,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.747,76.172c-2.254,0-4.081-1.827-4.081-4.081v-15.16c0-1.885,1.291-3.525,3.124-3.967.177-.044,18.436-4.665,18.436-16.952,0-7.71-6.32-13.095-15.371-13.095-9.8,0-14.838,9.797-15.047,10.214-1.01,2.007-3.455,2.83-5.468,1.829-2.012-1.001-2.841-3.432-1.848-5.448.296-.602,7.433-14.757,22.364-14.757,13.636,0,23.533,8.94,23.533,21.258,0,14.845-14.895,21.645-21.559,23.943v12.136c0,2.254-1.827,4.081-4.081,4.081Z",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoShowLady);
export default __webpack_public_path__ + "static/media/no-show-lady.86ab1c84cb0f5095f3d9c9b1d4e29991.svg";
export { ForwardRef as ReactComponent };